// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"couponManagement_wrapper__14SUw","left":"couponManagement_left__20JUY","right":"couponManagement_right__3ymML"};